import { render, staticRenderFns } from "./status_form.vue?vue&type=template&id=619f2e4e&"
import script from "./status_form.vue?vue&type=script&lang=js&"
export * from "./status_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports